import React, { useCallback } from 'react';

import Switch from '@mui/material/Switch';

interface ToggleCellProps {
  id: string;
  value: boolean;
  onClick: (params: { id: string; isSuspended: boolean }) => void;
  disabled?: boolean;
}

const ToggleCell: React.FC<ToggleCellProps> = ({ id, value, onClick, disabled = false }) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onClick({ id, isSuspended: e.target.checked });
    },
    [onClick, id],
  );

  return <Switch checked={value} onChange={handleChange} color="error" disabled={disabled} />;
};

export default ToggleCell;
